/**
 * Button — 공통 버튼 컴포넌트
 *
 * loading 상태에서는 Spinner를 인라인으로 표시하고 클릭을 비활성화한다.
 */

import { ButtonHTMLAttributes } from 'react'
import { cn } from '../../lib/cn.js'
import { Spinner } from './Spinner.js'
import styles from './Button.module.css'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** 버튼 시각적 변형. 기본값 primary */
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'outline'
  /** 버튼 크기. 기본값 md */
  size?: 'sm' | 'md' | 'lg'
  /** true일 때 Spinner 표시 + 클릭 비활성화 */
  loading?: boolean
}

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      disabled={disabled || loading}
      className={cn(
        styles.root,
        styles[variant],
        styles[size],
        loading && styles.loading,
        className,
      )}
    >
      {loading && <Spinner size="sm" />}
      {children}
    </button>
  )
}
